import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Render an outline-only card (no shadow). Use for nested cards. */
  flat?: boolean;
  /** Add an interactive hover state (raises shadow). */
  interactive?: boolean;
}

/**
 * Surface primitive. Atlassian-style raised panel with rounded corners,
 * subtle two-layer shadow, and a hover-elevation variant when used as
 * a clickable card.
 */
export const Card: React.FC<CardProps> = ({
  flat,
  interactive,
  className = '',
  children,
  ...rest
}) => (
  <div
    {...rest}
    className={
      'bg-white rounded-lg border border-slate-200 ' +
      (flat ? '' : 'shadow-card ') +
      (interactive ? 'transition-shadow hover:shadow-card-hover cursor-pointer ' : '') +
      className
    }
  >
    {children}
  </div>
);

export const CardHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className = '',
  children,
  ...rest
}) => (
  <div
    {...rest}
    className={'px-5 py-4 border-b border-slate-200 flex items-center justify-between ' + className}
  >
    {children}
  </div>
);

export const CardBody: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className = '',
  children,
  ...rest
}) => (
  <div {...rest} className={'px-5 py-4 ' + className}>
    {children}
  </div>
);

export default Card;
